export var RoleScope;
(function (RoleScope) {
    RoleScope["Firm"] = "firm";
    RoleScope["Global"] = "global";
})(RoleScope || (RoleScope = {}));
// These are permissions that are not assignable to any roles by non super-admins.
// They typically relate to cross-firm endpoints.
export var UnassignablePermission;
(function (UnassignablePermission) {
    UnassignablePermission["DeleteUsers"] = "delete:users";
    UnassignablePermission["CreateUsers"] = "create:users";
    UnassignablePermission["ReadAdminUserOrganisationMembership"] = "read:admin-user-organisation-membership";
    UnassignablePermission["CreateAdminUserOrganisationMembership"] = "create:admin-user-organisation-membership";
    UnassignablePermission["DeleteAdminUserOrganisationMembership"] = "delete:admin-user-organisation-membership";
    UnassignablePermission["ReadAuth0Organisations"] = "read:auth0-organisations";
    UnassignablePermission["CreateTag"] = "create:tag";
    UnassignablePermission["EditTag"] = "edit:tag";
    UnassignablePermission["DeleteTag"] = "delete:tag";
    UnassignablePermission["ReadLinkedPortals"] = "read:linked-portals";
    UnassignablePermission["CreateLinkedPortals"] = "create:linked-portals";
    UnassignablePermission["DeleteLinkedPortals"] = "delete:linked-portals";
    UnassignablePermission["ExecuteScripts"] = "execute:scripts";
    UnassignablePermission["ReadCollectionHistory"] = "read:collection-history";
    UnassignablePermission["CreateFirm"] = "create:firm";
    UnassignablePermission["DeleteFirm"] = "delete:firm";
    UnassignablePermission["ReadFurtherUser"] = "read:further-user";
    UnassignablePermission["DeleteFurtherUser"] = "delete:further-user";
    UnassignablePermission["ReadFurtherUserPasswordResetLink"] = "read:further-user-password-reset-link";
    UnassignablePermission["LpAllVehiclesMember"] = "lp:all-vehicles-member";
})(UnassignablePermission || (UnassignablePermission = {}));
export var LpPermission;
(function (LpPermission) {
    LpPermission["ReadGl"] = "read:gl";
    LpPermission["LpCreateAccount"] = "lp:create:account";
    LpPermission["LpCreateBankAccount"] = "lp:create:bank-account";
    LpPermission["LpCreateBankAccountOperation"] = "lp:create:bank-account-operation";
    LpPermission["LpCreateCapitalAction"] = "lp:create:capital-action";
    LpPermission["LpReadEqualisations"] = "lp:read:equalisations";
    LpPermission["LpCreateEqualisation"] = "lp:create:equalisation";
    LpPermission["LpEditEqualisation"] = "lp:edit:equalisation";
    LpPermission["LpDeleteEqualisation"] = "lp:delete:equalisation";
    LpPermission["LpCreateIncomeAndExpenses"] = "lp:create:income-and-expenses";
    LpPermission["LpReadInvestment"] = "lp:read:investment";
    LpPermission["LpCreateInvestment"] = "lp:create:investment";
    LpPermission["LpDeleteInvestment"] = "lp:delete:investment";
    LpPermission["LpCreateRealisation"] = "lp:create:realisation";
    LpPermission["LpCreateTransactionType"] = "lp:create:transaction-type";
    LpPermission["LpCreateUnrealisedAssetFxGainOrLoss"] = "lp:create:unrealised-asset-fx-gain-or-loss";
    LpPermission["LpCreateUnrealisedCashFxGainOrLoss"] = "lp:create:unrealised-cash-fx-gain-or-loss";
    LpPermission["LpCreateUnrealisedFxGainOrLoss"] = "lp:create:unrealised-fx-gain-or-loss";
    LpPermission["LpCreateVehicle"] = "lp:create:vehicle";
    LpPermission["LpDeleteAccount"] = "lp:delete:account";
    LpPermission["LpDeleteBankAccountOperation"] = "lp:delete:bank-account-operation";
    LpPermission["LpDeleteIncomeAndExpenses"] = "lp:delete:income-and-expenses";
    LpPermission["LpDeleteRealisation"] = "lp:delete:realisation";
    LpPermission["LpDeleteTransactionType"] = "lp:delete:transaction-type";
    LpPermission["LpDeleteRevaluation"] = "lp:delete:revaluation";
    LpPermission["LpDeleteUnrealisedAssetFxGainOrLoss"] = "lp:delete:unrealised-asset-fx-gain-or-loss";
    LpPermission["LpDeleteUnrealisedCashFxGainOrLoss"] = "lp:delete:unrealised-cash-fx-gain-or-loss";
    LpPermission["LpDeleteUnrealisedFxGainOrLoss"] = "lp:delete:unrealised-fx-gain-or-loss";
    LpPermission["LpEditAccount"] = "lp:edit:account";
    LpPermission["LpEditBankAccount"] = "lp:edit:bank-account";
    LpPermission["LpEditBankAccountOperation"] = "lp:edit:bank-account-operation";
    LpPermission["LpEditCapitalAction"] = "lp:edit:capital-action";
    LpPermission["LpEditCapitalActionNotice"] = "lp:edit:capital-action-notice";
    LpPermission["LpDeleteCapitalAction"] = "lp:delete:capital-action";
    LpPermission["LpDeleteCapitalActionNotice"] = "lp:delete:capital-action-notice";
    LpPermission["LpEditCommitment"] = "lp:edit:commitment";
    LpPermission["LpDeleteCommitment"] = "lp:delete:commitment";
    LpPermission["LpEditFee"] = "lp:edit:fee";
    LpPermission["LpEditIncomeAndExpenses"] = "lp:edit:income-and-expenses";
    LpPermission["LpEditTransactionType"] = "lp:edit:transaction-type";
    LpPermission["LpEditVehicle"] = "lp:edit:vehicle";
    LpPermission["LpReadAccounts"] = "lp:read:accounts";
    LpPermission["LpReadActions"] = "lp:read:actions";
    LpPermission["LpReadBankAccount"] = "lp:read:bank-account";
    LpPermission["LpReadBankFeed"] = "lp:read:bank-feed";
    LpPermission["LpReadCapitalAction"] = "lp:read:capital-action";
    LpPermission["LpReadCapitalActionNotice"] = "lp:read:capital-action-notice";
    LpPermission["LpReadCommitment"] = "lp:read:commitment";
    LpPermission["LpReadContacts"] = "lp:read:contacts";
    LpPermission["LpReadFee"] = "lp:read:fee";
    LpPermission["LpReadFeeTemplate"] = "lp:read:fee-template";
    LpPermission["LpReadHoldingClasses"] = "lp:read:holding-classes";
    LpPermission["LpReadIncomeAndExpenses"] = "lp:read:income-and-expenses";
    LpPermission["LpReadRealisation"] = "lp:read:realisation";
    LpPermission["LpReadReversal"] = "lp:read:reversal";
    LpPermission["LpCreateReversal"] = "lp:create:reversal";
    LpPermission["LpDeleteReversal"] = "lp:delete:reversal";
    LpPermission["LpReadUnrealisedAssetFxGainOrLoss"] = "lp:read:unrealised-asset-fx-gain-or-loss";
    LpPermission["LpReadUnrealisedCashFxGainOrLoss"] = "lp:read:unrealised-cash-fx-gain-or-loss";
    LpPermission["LpReadUnrealisedFxGainOrLoss"] = "lp:read:unrealised-fx-gain-or-loss";
    LpPermission["LpReadVehicles"] = "lp:read:vehicles";
    LpPermission["LpReadAssets"] = "lp:read:assets";
    LpPermission["LpCreateAsset"] = "lp:create:asset";
    LpPermission["LpEditAsset"] = "lp:edit:asset";
    LpPermission["LpWriteHoldingClasses"] = "lp:write:holding-classes";
    LpPermission["LpReadPartnerTransfers"] = "lp:read:partner-transfers";
    LpPermission["LpCreatePartnerTransfer"] = "lp:create:partner-transfer";
    LpPermission["LpEditPartnerTransfer"] = "lp:edit:partner-transfer";
    LpPermission["LpDeletePartnerTransfer"] = "lp:delete:partner-transfer";
    LpPermission["LpReadPrepayments"] = "lp:read:prepayments";
    LpPermission["LpReadAccruals"] = "lp:read:accruals";
    LpPermission["LpCreatePrepayments"] = "lp:create:prepayments";
    LpPermission["LpReadAccountingPeriod"] = "lp:read:accounting-period";
    LpPermission["LpEditAccountingPeriod"] = "lp:edit:accounting-period";
    LpPermission["LpReadManualJournal"] = "lp:read:manual-journal";
    LpPermission["LpCreateManualAction"] = "lp:create:manual-action";
    LpPermission["LpDeleteManualAction"] = "lp:delete:manual-action";
    LpPermission["LpEditManualAction"] = "lp:edit:manual-action";
    LpPermission["LpEditInvestorKyc"] = "lp:edit:investor-kyc";
    LpPermission["LpReadInvestorUpdates"] = "lp:read:investor-updates";
    LpPermission["LpCreateInvestorUpdate"] = "lp:create:investor-update";
    LpPermission["LpEditInvestorUpdate"] = "lp:edit:investor-update";
    LpPermission["LpDeleteInvestorUpdate"] = "lp:delete:investor-update";
})(LpPermission || (LpPermission = {}));
export var CommonPermission;
(function (CommonPermission) {
    // admin user roles
    CommonPermission["CreateRole"] = "create:role";
    CommonPermission["ReadRole"] = "read:role";
    CommonPermission["UpdateRole"] = "update:role";
    CommonPermission["DeleteRole"] = "delete:role";
    // admin user management
    CommonPermission["ReadUsers"] = "read:users";
    CommonPermission["EditUsers"] = "edit:users";
    CommonPermission["RemoveUserFromFirm"] = "delete:users:current-firm";
    CommonPermission["AddUserToFirm"] = "create:users:current-firm";
    CommonPermission["ManageUserSecurity"] = "manage:user-security";
    // impersonation access
    CommonPermission["UseImpersonationAccessInvestor"] = "use:impersonation-access:investor";
    // firms (both LP and EIS accordingly)
    CommonPermission["ReadFirm"] = "read:firm";
    CommonPermission["EditFirm"] = "edit:firm";
    // investors (LP and EIS shared collection)
    CommonPermission["CreateInvestor"] = "create:investor";
    CommonPermission["ReadInvestor"] = "read:investor";
    CommonPermission["EditInvestor"] = "edit:investor";
    CommonPermission["DeleteInvestor"] = "delete:investor";
})(CommonPermission || (CommonPermission = {}));
export var EisPermission;
(function (EisPermission) {
    EisPermission["CreateAdvisers"] = "create:advisers";
    EisPermission["ReadAdvisers"] = "read:advisers";
    EisPermission["EditAdvisers"] = "edit:advisers";
    EisPermission["DeleteAdvisers"] = "delete:advisers";
    EisPermission["CreateAllocationUpload"] = "create:allocationupload";
    EisPermission["ViewAllocationUpload"] = "view:allocationupload";
    EisPermission["EditAllocationUpload"] = "edit:allocationupload";
    EisPermission["DeleteAllocationUpload"] = "delete:allocationupload";
    EisPermission["CreateBackgroundExport"] = "create:background-export";
    EisPermission["ReadBackgroundExport"] = "read:background-export";
    EisPermission["DeleteBackgroundExport"] = "delete:background-export";
    EisPermission["CreateCompanies"] = "create:companies";
    EisPermission["ReadCompanies"] = "read:companies";
    EisPermission["EditCompanies"] = "edit:companies";
    EisPermission["DeleteCompanies"] = "delete:companies";
    EisPermission["CreateCoreFees"] = "create:corefees";
    EisPermission["ReadCoreFees"] = "read:corefees";
    EisPermission["DeleteCoreFees"] = "delete:corefees";
    EisPermission["CreateExit"] = "create:exit";
    EisPermission["ReadExit"] = "read:exit";
    EisPermission["DeleteExit"] = "delete:exit";
    EisPermission["EditExit"] = "edit:exit";
    EisPermission["ReadInterest"] = "read:interest";
    EisPermission["DeleteInterest"] = "delete:interest";
    EisPermission["UploadInterest"] = "upload:interest";
    EisPermission["CreateInvestment"] = "create:investment";
    EisPermission["ReadInvestment"] = "read:investment";
    EisPermission["EditInvestment"] = "edit:investment";
    EisPermission["DeleteInvestment"] = "delete:investment";
    EisPermission["CreateInvestorAccessGrant"] = "create:investor-access-grant";
    EisPermission["ReadInvestorAccessGrant"] = "read:investor-access-grant";
    EisPermission["EditInvestorAccessGrant"] = "edit:investor-access-grant";
    EisPermission["DeleteInvestorAccessGrant"] = "delete:investor-access-grant";
    EisPermission["DeleteInvestorCertification"] = "delete:investor-certification";
    EisPermission["ReadInvestorKyc"] = "read:investor-kyc";
    EisPermission["EditInvestorKyc"] = "edit:investor-kyc";
    EisPermission["CreateOrganisationUsers"] = "create:organisation-users";
    EisPermission["ReadOrganisationUsers"] = "read:organisation-users";
    EisPermission["DeleteOrganisationUsers"] = "delete:organisation-users";
    EisPermission["CreateOrganisations"] = "create:organisations";
    EisPermission["ReadOrganisations"] = "read:organisations";
    EisPermission["EditOrganisations"] = "edit:organisations";
    EisPermission["DeleteOrganisations"] = "delete:organisations";
    EisPermission["ReadPaymentExpectations"] = "read:payment-expectations";
    EisPermission["CreatePerformanceFees"] = "create:performancefees";
    EisPermission["ReadPerformanceFees"] = "read:performancefees";
    EisPermission["DeletePerformanceFees"] = "delete:performancefees";
    EisPermission["CreateSeis"] = "create:seis";
    EisPermission["CreateSeisWithoutCertificates"] = "create:seis-without-certificates";
    EisPermission["ReadSeis"] = "read:seis";
    EisPermission["EditSeis"] = "edit:seis";
    EisPermission["DeleteSeis"] = "delete:seis";
    EisPermission["DownloadSeis"] = "download:seis";
    EisPermission["CreateShareSplit"] = "create:share-split";
    EisPermission["DeleteShareSplit"] = "delete:share-split";
    EisPermission["ReadShareSplit"] = "read:share-split";
    EisPermission["CreateTranche"] = "create:tranche";
    EisPermission["ReadTranche"] = "read:tranche";
    EisPermission["EditTranche"] = "edit:tranche";
    EisPermission["DeleteTranche"] = "delete:tranche";
    EisPermission["DuplicateTranche"] = "duplicate:tranche";
    EisPermission["DeleteTransfer"] = "delete:transfer";
    EisPermission["ReadTransfers"] = "read:transfers";
    EisPermission["TransferInvestment"] = "transfer:investment";
    EisPermission["ReadWithdrawals"] = "read:withdrawals";
    EisPermission["RequestWithdrawals"] = "request:withdrawals";
    EisPermission["UseImpersonationAccessAdviser"] = "use:impersonation-access:adviser";
    EisPermission["UseImpersonationAccessOrgUser"] = "use:impersonation-access:org-user";
    EisPermission["EditFurtherUser"] = "edit:further-user";
    EisPermission["ReadTag"] = "read:tag";
    EisPermission["ExportCustodianFees"] = "export:custodian-fees";
    EisPermission["ExportCustodianWithdrawals"] = "export:custodian-withdrawals";
    EisPermission["CreateOneOffFeesAndDiscounts"] = "create:one-off-fees-and-discounts";
    EisPermission["DeleteOneOffFeesAndDiscounts"] = "delete:one-off-fees-and-discounts";
    EisPermission["UploadInvestorFull"] = "upload:investor-full";
    EisPermission["UploadInvestorBasic"] = "upload:investor-basic";
    EisPermission["ReadDashboards"] = "read:dashboards";
    EisPermission["CreatePlatformInvites"] = "create:platform-invites";
    EisPermission["CreateInvestmentFreeze"] = "create:investment-freeze";
    EisPermission["EditIncompleteSubscription"] = "edit:incomplete-subscriptions";
    EisPermission["DeleteIncompleteSubscription"] = "delete:incomplete-subscriptions";
    // communications
    EisPermission["ReadInvestorCommunications"] = "read:investor-communications";
    EisPermission["CreateReportPeriodic"] = "create:report-periodic";
    EisPermission["CreateReportCustom"] = "create:report-custom";
    EisPermission["CreateReportDeployment"] = "create:report-deployment";
    EisPermission["CreateReportExitStatement"] = "create:report-exit-statement";
    EisPermission["EditReportPeriodic"] = "edit:report-periodic";
    EisPermission["EditReportCustom"] = "edit:report-custom";
    EisPermission["EditReportDeployment"] = "edit:report-deployment";
    EisPermission["EditReportExitStatement"] = "edit:report-exit-statement";
    EisPermission["DeleteReportPeriodic"] = "delete:report-periodic";
    EisPermission["DeleteReportCustom"] = "delete:report-custom";
    EisPermission["DeleteReportDeployment"] = "delete:report-deployment";
    EisPermission["DeleteReportExitStatement"] = "delete:report-exit-statement";
    EisPermission["PublishReportPeriodic"] = "publish:report-periodic";
    EisPermission["PublishReportCustom"] = "publish:report-custom";
    EisPermission["EditInvestorBulletin"] = "edit:investor-bulletin";
    EisPermission["EditTaxReport"] = "edit:tax-report";
})(EisPermission || (EisPermission = {}));
export const RolePermission = {
    ...UnassignablePermission,
    ...CommonPermission,
    ...EisPermission,
    ...LpPermission,
};
//# sourceMappingURL=index.js.map